/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// ng2-charts provider helpers
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

// Option A — register everything (quick)
bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
        ...(appConfig.providers ?? []),
        provideCharts(withDefaultRegisterables()),
    ],
}).catch((err) => console.error(err));